// extracted by mini-css-extract-plugin
export default {"Box_0":"FilterInputIcon-module__Box_0--GpqZN","Octicon_0":"FilterInputIcon-module__Octicon_0--aj4CD"};